import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DialogService, ToastrService} from '@kpmg-tax/ui';

import {SessionService} from '../../shared/session-service/session.service';
import {API_URL} from '../../shared/constants/apiurl-constants';
import { UpdateReconcileRow } from 'src/app/shared/models/reconcile-survey/reconcile.model';

@Injectable({
  providedIn: 'root',
})
export class ReconcilationDetailsService {
  private _row: any = null;
  get Row(): any {
    return this._row;
  }
  set Row(value: any) {
    this._row = value;
  }
  constructor(
    public sessionService: SessionService,
    public dialogService: DialogService,
    public toastrService: ToastrService,
  ) {}

  getReconcilationDetails(engagementId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.SURVEY.GETRECONCILESURVEYDETAILS +
        '?engagementId=' +
        engagementId,
    );
  }

  updateReconcileSurveydetails(data: any) {
    return this.sessionService.apiUrlPost(
      API_URL.SURVEY.UPDATERECONCILESURVEYCELL,
      data,
    );
  }

  updateMultipleReconcileSurveydetails(empReconciledData:Array<UpdateReconcileRow>) {
    return this.sessionService.apiUrlPost(
      API_URL.SURVEY.UPDATEMULTIPLERECONCILESURVEYCELL,
      empReconciledData,
    );
  }
}
